(() => {
  const script = document.querySelector('script[data-sca-gallery-navigation]');
  if (!script) return;
  const ready = new WeakMap();
  const selector = '.scapd-gallery, .product-gallery';
  function mount(gallery) {
    if (ready.has(gallery)) return;
    const choices = () => [...gallery.querySelectorAll('[data-evasion-target], [data-scapd-image], .thumbnail[data-src]')]
      .filter(item => !item.closest('[hidden]') && getComputedStyle(item).display !== 'none');
    const stage = () => [...gallery.querySelectorAll('.scapd-photo, .main-image')].find(item => !item.hidden);
    if (!stage()) return;
    gallery.classList.add('sca-gallery-navigation');
    const controls = document.createElement('div');
    controls.className = 'sca-gallery-controls';
    const buttons = [-1, 1].map(delta => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sca-gallery-arrow';
      button.dataset.direction = String(delta);
      button.setAttribute('aria-label', delta < 0 ? script.dataset.previous : script.dataset.next);
      button.innerHTML = `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="${delta < 0 ? 'm14 5-7 7 7 7' : 'm10 5 7 7-7 7'}"/></svg>`;
      controls.appendChild(button);
      return button;
    });
    gallery.appendChild(controls);
    const path = value => { try { return new URL(value, location.href).pathname; } catch { return value; } };
    function activeIndex(items) {
      const selected = items.findIndex(item => item.getAttribute('aria-pressed') === 'true' || item.classList.contains('selected-thumbnail'));
      if (selected >= 0) return selected;
      const src = gallery.querySelector('.scapd-main-image, #main-image')?.getAttribute('src');
      return Math.max(0, items.findIndex(item => path(item.dataset.scapdImage || item.dataset.src) === path(src)));
    }
    let observedStage;
    const resize = new ResizeObserver(update);
    function update() {
      if (!gallery.isConnected) { resize.disconnect(); observer.disconnect(); return; }
      const photo = stage();
      controls.hidden = choices().length < 2 || !photo;
      if (!photo) return;
      if (observedStage !== photo) {
        if (observedStage) resize.unobserve(observedStage);
        observedStage = photo;
        resize.observe(photo);
      }
      const frame = gallery.getBoundingClientRect(), rect = photo.getBoundingClientRect();
      controls.style.top = `${rect.top - frame.top + gallery.scrollTop}px`;
      controls.style.left = `${rect.left - frame.left + gallery.scrollLeft}px`;
      controls.style.width = `${rect.width}px`;
      controls.style.height = `${rect.height}px`;
    }
    buttons.forEach(button => button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const items = choices();
      if (items.length < 2) return;
      const next = (activeIndex(items) + Number(button.dataset.direction) + items.length) % items.length;
      items[next].click();
      update();
    }));
    const observer = new MutationObserver(records => {
      if (records.some(record => record.target.matches('[data-evasion-target], [data-scapd-image], .thumbnail, [data-evasion-panel], .scapd-main-image, #main-image'))) update();
    });
    observer.observe(gallery, {subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-pressed', 'class', 'src']});
    gallery.addEventListener('load', update, true);
    resize.observe(gallery);
    ready.set(gallery, {resize, observer});
    update();
  }
  function setup(root = document) {
    if (root.matches?.(selector)) mount(root);
    root.querySelectorAll(selector).forEach(mount);
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(gallery => {
      const state = ready.get(gallery);
      state?.resize.disconnect();
      state?.observer.disconnect();
      ready.delete(gallery);
    });
  });
})();
